import { useState } from 'react';
import { Button } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useDownloadQuestionnaireExport } from '../../../global/entities/Questionnaires/mutations/useDownloadQuestionnaireExport.tsx';
import QuestionnaireExportPasswordModal from './QuestionnaireExportPasswordModal.tsx';

interface HcfQuestionnaireExportButtonProps {
    facilityId: number;
}

export default function HcfQuestionnaireExportButton({ facilityId }: HcfQuestionnaireExportButtonProps) {
    const { t } = useTranslation();
    const [modalOpened, setModalOpened] = useState(false);
    const downloadExport = useDownloadQuestionnaireExport();

    const handleSubmitPassword = (password: string) => {
        downloadExport.mutate({ healthcareFacilityId: facilityId, password });
        setModalOpened(false);
    };

    return (
        <>
            <Button
                variant="light"
                leftSection={<IconDownload size={16} />}
                onClick={() => setModalOpened(true)}
            >
                {t('questionnaireExport.downloadButton')}
            </Button>
            <QuestionnaireExportPasswordModal
                opened={modalOpened}
                onClose={() => setModalOpened(false)}
                onSubmit={handleSubmitPassword}
                isSubmitting={downloadExport.isPending}
            />
        </>
    );
}
